import { Search, Users, Globe, ShieldCheck } from "lucide-react";

const reasons = [
  {
    icon: Search,
    title: "Independent Legal Due Diligence",
    description: "We conduct comprehensive legal investigations into property titles, ownership history, and encumbrances before any acquisition is completed."
  },
  {
    icon: Users,
    title: "Investor-Focused Advisory",
    description: "Our practice focuses on advising investors and private clients seeking secure property transactions in Nigeria."
  },
  {
    icon: Globe,
    title: "Trusted by Diaspora Clients",
    description: "We regularly advise diaspora investors purchasing property in Nigeria and requiring reliable legal oversight."
  },
  {
    icon: ShieldCheck,
    title: "Structured Transaction Oversight",
    description: "Our firm supervises the entire acquisition process to ensure the transaction is completed securely and in compliance with Nigerian law."
  }
];

export const WhyChooseUs = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="why-choose-us"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            The 4ACES Difference
          </span>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 leading-tight">
            Why Investors Choose
            <span className="block text-[#D4AF37] italic">4ACES Attorneys</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
          
          {/* Introduction paragraph */}
          <p className="max-w-3xl mx-auto mt-8 md:mt-10 text-white/60 text-sm md:text-base lg:text-lg leading-relaxed">
            Our firm provides strategic legal counsel for investors seeking secure property 
            acquisitions in Nigeria. We combine rigorous legal due diligence with practical 
            transaction advisory to protect our clients' investments.
          </p>
        </div>

        {/* 4-Point Grid */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
          {reasons.map((reason, index) => (
            <div 
              key={index} 
              className="group p-6 md:p-8 border border-[#D4AF37]/15 hover:border-[#D4AF37]/40 bg-[#0A0A0B]/50 transition-all duration-300"
              data-testid={`reason-${index}`}
            >
              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 md:w-14 md:h-14 border border-[#D4AF37]/30 flex items-center justify-center flex-shrink-0 group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-300">
                  <reason.icon className="w-5 h-5 md:w-6 md:h-6 text-[#D4AF37]" />
                </div>
                <div>
                  <h3 className="font-['Playfair_Display'] text-lg md:text-xl text-white mb-2 md:mb-3">
                    {reason.title}
                  </h3>
                  <p className="text-white/50 text-sm md:text-base leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
